// import React from "react";

// export default function ActiveOverview({ dashboardData, progressPercentage, onNavigate }) {
//   const { current_visit, next_reward, all_passes, unlocked_rewards } = dashboardData;

//   return (
//     <div style={{ animation: "fadeIn 0.4s ease" }}>
//       {/* Roadmap Timeline */}
//       <div className="timeline-card">
//         <h3>🎁 Loyalty Passes Roadmap</h3>
//         <div className="timeline-slider">
//           {all_passes?.map((pass) => {
//             const isNextTarget = next_reward && next_reward.pass_id === pass.id;
//             const isCompleted = parseInt(current_visit) >= parseInt(pass.total_visits);

//             return (
//               <div key={pass.id} className={`timeline-item ${isNextTarget ? "next-up" : ""}`}>
//                 <h5>🎯 On {pass.total_visits} Visits</h5>
//                 <p>{pass.reward}</p>
//                 {isCompleted ? (
//                   <span className="timeline-badge" style={{ background: "#ecfdf5", color: "#059669" }}>Unlocked 🎉</span>
//                 ) : isNextTarget ? (
//                   <span className="timeline-badge" style={{ background: "#ffea2c", color: "#111827" }}>Next Target 🎯</span>
//                 ) : (
//                   <span className="timeline-badge" style={{ background: "#e5e7eb", color: "#6b7280" }}>Locked 🔒</span>
//                 )}
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* Main Stats Split Grid */}
//       <div className="current-visit">
//         {/* Progress Card */}
//         <div className="card">
//           <h3>Your Current Visit Progress</h3>
//           <div 
//             className="visit-ring"
//             style={{ background: `conic-gradient(#ff8c42 0% ${progressPercentage}%, #e5e7eb ${progressPercentage}% 100%)` }}
//           >
//             <div className="ring-inner">
//               <h1>{current_visit}</h1>
//               <p>Visits Done</p>
//             </div>
//           </div>

//           {next_reward ? (
//             <div className="milestone">
//               <h4>Next Milestone: {next_reward.title}</h4>
//               <div className="progress">
//                 <div className="progress-fill" style={{ width: `${progressPercentage}%` }}></div>
//               </div>
//               <p>Only <b>{next_reward.remaining_visits}</b> visit left to unlock reward worth <b>₹{next_reward.reward}</b> 🎉</p>
//             </div>
//           ) : (
//             <div className="milestone">
//               <p style={{ color: "#10b981", fontWeight: "700" }}>Woohoo! All loyalty targets reached! 🏁</p>
//             </div>
//           )}
//         </div>

//         {/* Quick Claim Card */}
//         <div className="reward-card">
//           <div>
//             {unlocked_rewards && unlocked_rewards.length > 0 ? (
//               <>
//                 <div className="reward-tag">Reward Ready!</div>
//                 <h2>{unlocked_rewards[0].title || "Discount Coupon"}</h2>
//                 <p>Value/Reward: <b>₹{unlocked_rewards[0].reward}</b></p>
//                 <div className="coupon" style={{ fontSize: "14px", letterSpacing: "normal" }}> 
//                   Go to "My Unlocked Rewards" tab to redeem 
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="reward-tag" style={{ background: "#6b7280" }}>No Instant Claims</div>
//                 <h2>Keep Visiting!</h2>
//                 <p>Once your target completes, your active coupon codes will unlock instantly right here.</p>
//                 <div className="coupon" style={{ background: "#374151", letterSpacing: "normal", fontSize: "16px" }}>
//                   LOCKED 🔒
//                 </div>
//               </>
//             )}
//           </div>
//           <button className="feedback-btn" onClick={() => onNavigate("/feedback")}>Give Feedback →</button>
//         </div>
//       </div>
//     </div>
//   );
// }

import React from "react";

export default function ActiveOverview({
  dashboardData,
  progressPercentage,
  onNavigate,
}) {
  const currentVisit = parseInt(dashboardData?.current_visit || 0);

  const nextReward = dashboardData?.next_reward || null;
  const allPasses = dashboardData?.all_passes || [];
  const merchant = dashboardData?.merchant || null;

  const maxVisits = nextReward
    ? parseInt(nextReward.required_visits || 1)
    : 1;

  const isCompleted =
    nextReward && currentVisit >= maxVisits;

  const rewardText =
    nextReward?.reward ||
    dashboardData?.reward ||
    "Keep visiting";

  return (
    <>
      <style>{`

        /* =========================================================
           LIVE OVERVIEW
        ========================================================= */

        .overview-wrapper {
          width: 100%;
          animation: overviewFade .45s ease;
        }

        @keyframes overviewFade {
          from {
            opacity: 0;
            transform: translateY(15px);
          }

          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* =========================================================
           HERO
        ========================================================= */

        .overview-hero {
          position: relative;
          overflow: hidden;
          min-height: 260px;
          border-radius: 32px;
          padding: 38px;
          margin-bottom: 28px;

          background:
            radial-gradient(
              circle at 85% 15%,
              rgba(255,255,255,.22),
              transparent 30%
            ),
            linear-gradient(
              135deg,
              #111827 0%,
              #1e293b 48%,
              #334155 100%
            );

          color: white;
          box-shadow:
            0 25px 60px rgba(15,23,42,.18);

          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 30px;
        }

        .overview-hero::before {
          content: "";
          position: absolute;
          width: 230px;
          height: 230px;
          border-radius: 50%;
          right: -70px;
          top: -100px;

          background: rgba(255,255,255,.07);
        }

        .overview-hero::after {
          content: "";
          position: absolute;
          width: 180px;
          height: 180px;
          border-radius: 50%;
          right: 150px;
          bottom: -130px;

          background: rgba(255,255,255,.05);
        }

        .hero-content {
          position: relative;
          z-index: 2;
          max-width: 650px;
        }

        .live-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;

          padding: 8px 14px;
          border-radius: 30px;

          background: rgba(255,255,255,.1);
          border: 1px solid rgba(255,255,255,.15);

          font-size: 12px;
          font-weight: 800;
          letter-spacing: 1px;
          text-transform: uppercase;

          margin-bottom: 18px;
        }

        .live-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #22c55e;

          box-shadow:
            0 0 0 5px rgba(34,197,94,.12);

          animation: livePulse 1.8s infinite;
        }

        @keyframes livePulse {
          0% {
            box-shadow: 0 0 0 0 rgba(34,197,94,.4);
          }

          70% {
            box-shadow: 0 0 0 8px rgba(34,197,94,0);
          }

          100% {
            box-shadow: 0 0 0 0 rgba(34,197,94,0);
          }
        }

        .hero-content h2 {
          margin: 0;
          font-size: 38px;
          line-height: 1.15;
          font-weight: 850;
          letter-spacing: -1px;
        }

        .hero-content p {
          margin-top: 12px;
          color: #cbd5e1;
          font-size: 15px;
          line-height: 1.7;
          max-width: 570px;
        }

        .hero-business {
          margin-top: 18px;
          display: inline-flex;
          align-items: center;
          gap: 9px;

          color: #e2e8f0;
          font-size: 13px;
          font-weight: 600;
        }

        .hero-business span {
          color: white;
          font-weight: 800;
        }

        /* =========================================================
           HERO VISIT NUMBER
        ========================================================= */

        .hero-visit {
          position: relative;
          z-index: 3;

          min-width: 185px;
          height: 185px;

          border-radius: 50%;

          display: flex;
          align-items: center;
          justify-content: center;

          background:
            conic-gradient(
              #ff8c42 ${Math.min(progressPercentage || 0, 100)}%,
              rgba(255,255,255,.12) 0
            );

          box-shadow:
            0 20px 50px rgba(0,0,0,.2);
        }

        .hero-visit-inner {
          width: 148px;
          height: 148px;

          border-radius: 50%;

          background: #111827;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .hero-visit-number {
          font-size: 48px;
          line-height: 1;
          font-weight: 900;
        }

        .hero-visit-label {
          margin-top: 7px;
          color: #94a3b8;
          font-size: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: .8px;
        }

        /* =========================================================
           SECTION
        ========================================================= */

        .overview-section {
          background: rgba(255,255,255,.8);
          border: 1px solid rgba(226,232,240,.9);

          border-radius: 30px;
          padding: 30px;

          margin-bottom: 28px;

          box-shadow:
            0 12px 35px rgba(15,23,42,.06);
        }

        .section-heading {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 15px;

          margin-bottom: 24px;
        }

        .section-heading-left h3 {
          margin: 0;
          font-size: 23px;
          font-weight: 850;
          color: #0f172a;
        }

        .section-heading-left p {
          margin-top: 6px;
          color: #64748b;
          font-size: 13px;
        }

        .roadmap-count {
          padding: 8px 13px;
          border-radius: 20px;

          background: #fff7ed;
          color: #ea580c;

          font-size: 12px;
          font-weight: 800;
        }

        /* =========================================================
           ROADMAP
        ========================================================= */

        .roadmap {
          display: flex;
          gap: 16px;

          overflow-x: auto;

          padding: 5px 3px 18px;

          scroll-behavior: smooth;
        }

        .roadmap::-webkit-scrollbar {
          height: 6px;
        }

        .roadmap::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 20px;
        }

        .roadmap::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 20px;
        }

        .roadmap-card {
          position: relative;

          min-width: 225px;

          padding: 21px;

          border-radius: 22px;

          border: 1px solid #e2e8f0;

          background: white;

          transition:
            transform .25s ease,
            box-shadow .25s ease,
            border-color .25s ease;
        }

        .roadmap-card:hover {
          transform: translateY(-5px);

          border-color: #fed7aa;

          box-shadow:
            0 15px 30px rgba(15,23,42,.08);
        }

        .roadmap-card.completed {
          background:
            linear-gradient(
              145deg,
              #fff7ed,
              #ffffff
            );

          border-color: #fed7aa;
        }

        .roadmap-card.next {
          border: 2px solid #ff8c42;

          box-shadow:
            0 12px 30px rgba(255,140,66,.15);
        }

        .roadmap-top {
          display: flex;
          align-items: center;
          justify-content: space-between;

          margin-bottom: 18px;
        }

        .roadmap-icon {
          width: 43px;
          height: 43px;

          display: flex;
          align-items: center;
          justify-content: center;

          border-radius: 14px;

          background: #fff7ed;

          font-size: 21px;
        }

        .roadmap-status {
          padding: 6px 10px;
          border-radius: 20px;

          font-size: 10px;
          font-weight: 800;

          text-transform: uppercase;
        }

        .roadmap-status.done {
          background: #dcfce7;
          color: #15803d;
        }

        .roadmap-status.locked {
          background: #f1f5f9;
          color: #64748b;
        }

        .roadmap-card h4 {
          margin: 0;

          color: #0f172a;

          font-size: 17px;
          font-weight: 800;

          min-height: 42px;
        }

        .roadmap-target {
          margin-top: 8px;

          color: #64748b;

          font-size: 12px;
          font-weight: 600;
        }

        .roadmap-reward {
          margin-top: 15px;

          padding: 12px;

          border-radius: 13px;

          background: #f8fafc;

          color: #334155;

          font-size: 12px;
        }

        .roadmap-reward strong {
          display: block;

          margin-top: 3px;

          color: #0f172a;

          font-size: 14px;
        }

        /* =========================================================
           PROGRESS + REWARD
        ========================================================= */

        .stats-grid {
          display: grid;

          grid-template-columns:
            minmax(0, 1.3fr)
            minmax(300px, .7fr);

          gap: 24px;

          margin-bottom: 28px;
        }

        .progress-card,
        .reward-card {
          background: white;

          border-radius: 30px;

          padding: 30px;

          border: 1px solid #e2e8f0;

          box-shadow:
            0 12px 35px rgba(15,23,42,.06);
        }

        .card-label {
          color: #64748b;

          font-size: 12px;
          font-weight: 800;

          text-transform: uppercase;
          letter-spacing: .8px;
        }

        .progress-title {
          margin-top: 7px;

          color: #0f172a;

          font-size: 22px;
          font-weight: 850;
        }

        .progress-numbers {
          display: flex;
          align-items: flex-end;
          gap: 8px;

          margin-top: 25px;
        }

        .current-number {
          font-size: 54px;
          line-height: 1;

          font-weight: 900;

          color: #ff6b35;
        }

        .target-number {
          color: #94a3b8;

          font-size: 17px;
          font-weight: 700;

          margin-bottom: 6px;
        }

        .progress-track {
          height: 14px;

          margin-top: 25px;

          background: #f1f5f9;

          border-radius: 30px;

          overflow: hidden;
        }

        .progress-fill {
          height: 100%;

          border-radius: 30px;

          background:
            linear-gradient(
              90deg,
              #ff8c42,
              #ff5e62
            );

          transition: width .8s ease;
        }

        .progress-message {
          margin-top: 15px;

          color: #64748b;

          font-size: 13px;
          line-height: 1.6;
        }

        .progress-message strong {
          color: #0f172a;
        }

        /* =========================================================
           REWARD CARD
        ========================================================= */

        .reward-card {
          position: relative;
          overflow: hidden;

          color: white;

          background:
            radial-gradient(
              circle at 100% 0%,
              rgba(255,255,255,.15),
              transparent 35%
            ),
            linear-gradient(
              135deg,
              #f97316,
              #ef4444
            );
        }

        .reward-card::after {
          content: "🎁";

          position: absolute;

          right: -10px;
          bottom: -25px;

          font-size: 125px;

          opacity: .12;
          transform: rotate(-15deg);
        }

        .reward-small {
          position: relative;
          z-index: 2;

          font-size: 11px;
          font-weight: 800;

          letter-spacing: 1px;
          text-transform: uppercase;

          color: rgba(255,255,255,.8);
        }

        .reward-card h3 {
          position: relative;
          z-index: 2;

          margin-top: 9px;

          font-size: 25px;
          font-weight: 850;
        }

        .reward-value {
          position: relative;
          z-index: 2;

          margin-top: 20px;

          padding: 14px;

          border-radius: 16px;

          background: rgba(255,255,255,.14);

          border: 1px solid rgba(255,255,255,.18);

          font-size: 14px;
        }

        .reward-value strong {
          display: block;

          margin-top: 3px;

          font-size: 20px;
        }

        .reward-action {
          position: relative;
          z-index: 3;

          width: 100%;

          margin-top: 20px;

          height: 50px;

          border: none;
          border-radius: 15px;

          background: white;

          color: #ea580c;

          font-size: 14px;
          font-weight: 850;

          cursor: pointer;

          transition: transform .2s ease;
        }

        .reward-action:hover {
          transform: translateY(-2px);
        }

        /* =========================================================
           EMPTY ROADMAP
        ========================================================= */

        .empty-roadmap {
          padding: 45px 20px;

          text-align: center;

          border-radius: 22px;

          background: #f8fafc;
        }

        .empty-roadmap-icon {
          font-size: 42px;
          margin-bottom: 10px;
        }

        .empty-roadmap h4 {
          color: #0f172a;
          font-size: 18px;
        }

        .empty-roadmap p {
          margin-top: 6px;
          color: #64748b;
          font-size: 13px;
        }

        /* =========================================================
           MOBILE
        ========================================================= */

        @media (max-width: 900px) {

          .overview-hero {
            padding: 28px;
            min-height: auto;
            flex-direction: column;
            align-items: flex-start;
          }

          .hero-visit {
            width: 150px;
            min-width: 150px;
            height: 150px;

            align-self: center;
          }

          .hero-visit-inner {
            width: 120px;
            height: 120px;
          }

          .hero-visit-number {
            font-size: 38px;
          }

          .hero-content h2 {
            font-size: 30px;
          }

          .stats-grid {
            grid-template-columns: 1fr;
          }
        }

        @media (max-width: 600px) {

          .overview-section,
          .progress-card,
          .reward-card {
            padding: 22px;
            border-radius: 24px;
          }

          .overview-hero {
            padding: 24px;
            border-radius: 25px;
          }

          .hero-content h2 {
            font-size: 26px;
          }

          .hero-content p {
            font-size: 13px;
          }

          .section-heading-left h3 {
            font-size: 19px;
          }

          .roadmap-card {
            min-width: 205px;
          }

          .current-number {
            font-size: 45px;
          }
        }

      `}</style>

      <div className="overview-wrapper">

        {/* =====================================================
            HERO
        ===================================================== */}

        <div className="overview-hero">

          <div className="hero-content">

            <div className="live-badge">
              <span className="live-dot"></span>
              Live Loyalty
            </div>

            <h2>Your loyalty journey is active.</h2>

            <p>
              Keep visiting{" "}
              {merchant?.business_name
                ? ` ${merchant.business_name}`
                : "this store"}{" "}
              to unlock exclusive rewards and benefits.
            </p>

            {merchant?.business_name && (
              <div className="hero-business">
                🏪
                <span>{merchant.business_name}</span>
              </div>
            )}

          </div>

          <div
            className="hero-visit"
            style={{
              background: `conic-gradient(
                #ff8c42 ${Math.min(
                  progressPercentage || 0,
                  100
                )}%,
                rgba(255,255,255,.12) 0
              )`,
            }}
          >
            <div className="hero-visit-inner">
              <div className="hero-visit-number">
                {currentVisit}
              </div>

              <div className="hero-visit-label">
                Visits
              </div>
            </div>
          </div>

        </div>

        {/* =====================================================
            ROADMAP
        ===================================================== */}

        <div className="overview-section">

          <div className="section-heading">

            <div className="section-heading-left">
              <h3>🎁 Loyalty Passes Roadmap</h3>

              <p>
                Complete visits and unlock your rewards.
              </p>
            </div>

            <div className="roadmap-count">
              {allPasses.length} Passes
            </div>

          </div>

          {allPasses.length > 0 ? (

            <div className="roadmap">

              {allPasses.map((item, index) => {

                const requiredVisits =
                  parseInt(item.total_visits || 0);

                const completed =
                  currentVisit >= requiredVisits;

                const isNext =
                  !completed &&
                  currentVisit < requiredVisits &&
                  (
                    index === 0 ||
                    currentVisit >=
                      parseInt(
                        allPasses[index - 1]?.total_visits || 0
                      )
                  );

                return (
                  <div
                    key={item.id || index}
                    className={`roadmap-card ${
                      completed ? "completed" : ""
                    } ${isNext ? "next" : ""}`}
                  >

                    <div className="roadmap-top">

                      <div className="roadmap-icon">
                        {completed ? "🎉" : "🎯"}
                      </div>

                      <div
                        className={`roadmap-status ${
                          completed ? "done" : "locked"
                        }`}
                      >
                        {completed
                          ? "Unlocked"
                          : "In Progress"}
                      </div>

                    </div>

                    <h4>
                      {item.title || "Loyalty Reward"}
                    </h4>

                    <div className="roadmap-target">
                      🎯 On {requiredVisits} Visits
                    </div>

                    <div className="roadmap-reward">
                      Reward
                      <strong>
                        {item.reward || "Special Reward"}
                      </strong>
                    </div>

                  </div>
                );
              })}

            </div>

          ) : (

            <div className="empty-roadmap">

              <div className="empty-roadmap-icon">
                🎫
              </div>

              <h4>No loyalty passes available</h4>

              <p>
                This store hasn't added any loyalty targets yet.
              </p>

            </div>

          )}

        </div>

        {/* =====================================================
            PROGRESS + REWARD
        ===================================================== */}

        <div className="stats-grid">

          {/* PROGRESS */}

          <div className="progress-card">

            <div className="card-label">
              Your Current Visit Progress
            </div>

            <div className="progress-title">
              Keep going — you're making progress!
            </div>

            <div className="progress-numbers">

              <div className="current-number">
                {currentVisit}
              </div>

              <div className="target-number">
                /
                {maxVisits} visits
              </div>

            </div>

            <div className="progress-track">

              <div
                className="progress-fill"
                style={{
                  width: `${Math.min(
                    progressPercentage || 0,
                    100
                  )}%`,
                }}
              />

            </div>

            <div className="progress-message">

              {isCompleted ? (
                <>
                  <strong>
                    Woohoo! 🎉 Loyalty target reached.
                  </strong>
                  <br />
                  Your reward is ready to claim.
                </>
              ) : nextReward ? (
                <>
                  Only{" "}
                  <strong>
                    {Math.max(
                      maxVisits - currentVisit,
                      0
                    )}
                  </strong>{" "}
                  more visit
                  {maxVisits - currentVisit === 1
                    ? ""
                    : "s"}{" "}
                  to unlock{" "}
                  <strong>{rewardText}</strong>.
                </>
              ) : (
                <>
                  Keep visiting to unlock exciting rewards.
                </>
              )}

            </div>

          </div>

          {/* REWARD */}

          <div className="reward-card">

            <div className="reward-small">
              🎁 Reward Ready
            </div>

            <h3>
              Discount Coupon
            </h3>

            <div className="reward-value">
              Value / Reward

              <strong>
                ₹{rewardText}
              </strong>
            </div>

            <button
              className="reward-action"
              onClick={() =>
                onNavigate("my_rewards")
              }
            >
              View My Unlocked Rewards →
            </button>

          </div>

        </div>

      </div>
    </>
  );
}
 
